// "Take it" on a live-map alert (0366) — the request shapes the admin app sends
// and the admin Edge Function validates. One definition for both sides.
//
// An alert is not a row: the map derives it from live facts and names it with a
// stable key (`overdue-<booking>`, `disconnected-<staff>`…). A claim carries
// that key and the alert's hub; who is claiming is the verified JWT, never the
// body.

import { z } from "zod";

const uuidSchema = z.string().uuid();

export const claimOpsAlertSchema = z
  .object({
    alertKey: z.string().trim().min(1).max(200),
    /** The alert's hub; `null` for a page-level alert (a count with no hub). */
    hubId: uuidSchema.nullable(),
  })
  .strict();

export const finishOpsAlertClaimSchema = z
  .object({
    claimId: uuidSchema,
    /** `done` closes it; `released` gives it back for someone else to take. */
    outcome: z.enum(["done", "released"]),
  })
  .strict();

export type ClaimOpsAlertInput = z.infer<typeof claimOpsAlertSchema>;
export type FinishOpsAlertClaimInput = z.infer<typeof finishOpsAlertClaimSchema>;
